import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, NetworkIcon, ImageIcon, HeadphonesIcon, ClipboardListIcon, BabyIcon } from 'lucide-react';
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const deliverables = [{
    icon: BookOpenIcon,
    title: 'El Libro Digital "El Código del Vientre"',
    description: 'Guía completa paso a paso'
  }, {
    icon: NetworkIcon,
    title: 'El Protocolo de Reordenamiento Sistémico',
    description: 'Para identificar bloqueos ancestrales'
  }, {
    icon: ImageIcon,
    title: 'Guía de dibujo del Genograma de Fertilidad',
    description: 'Para visualizar tu lugar en el árbol'
  }, {
    icon: HeadphonesIcon,
    title: 'Meditación Narrada (Audio): "Código del Vientre"',
    description: 'Para recibir el permiso de dar vida'
  }, {
    icon: ClipboardListIcon,
    title: 'Ejercicio del "Lugar Vacío"',
    description: 'Para integrar duelos no resueltos en la familia'
  }, {
    icon: BabyIcon,
    title: 'Checklist de preparación de la "Cuna Emocional"',
    description: 'Para crear el espacio interno perfecto'
  }];
  return <section ref={ref} className="w-full bg-white py-6 md:py-10 px-6" data-id="element-269">
      <div className="max-w-6xl mx-auto" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-271">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-8 text-center" data-id="element-272">
            Lo Que Recibes
          </h2>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-273">
            {deliverables.map((item, index) => {
            const Icon = item.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={isInView ? {
              opacity: 1,
              scale: 1
            } : {}} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="bg-cream/50 rounded-2xl p-5 flex gap-4 items-start border border-gold/10 hover:border-gold/30 transition-colors" data-id="element-274">
                  <div className="flex-shrink-0" data-id="element-275">
                    <Icon className="w-8 h-8 text-gold" strokeWidth={1.5} data-id="element-276" />
                  </div>
                  <div data-id="element-277">
                    <h3 className="font-sans text-lg font-semibold text-brown mb-2" data-id="element-278">
                      {item.title}
                    </h3>
                    <p className="font-sans text-base text-brown/70" data-id="element-279">
                      {item.description}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}